import { BooleanRule } from '@/classes/rules/BooleanRule';
import { ObjectRule } from '@/classes/rules/ObjectRule';
import { MinMaxRule } from '@/classes/rules/MinMaxRule';

import { ScenarioGridExt } from '@/classes/scenario/grid/ScenarioGridExt';
import { DefaultValue } from '@/classes/rules/DefaultValue';
import { EnumRule } from '@/classes/rules/EnumRule';
import { ArrayRule } from '@/classes/rules/ArrayRule';
import { GridComplexPricingExt } from '@/classes/scenario/grid/GridComplexPricingExt';
import { GridAvailability } from '@/dto/scenario/grid/GridAvailability';
import { InjectionModelRef } from '@/dto/scenario/ScenarioReference';

// GRID RULES =========================================================
export const buildGridRules = () => new ObjectRule<ScenarioGridExt>('grid', [
  new BooleanRule('hasGrid24')
    .withIsAvailable(scenario => scenario.hasGrid || false),

  new BooleanRule('hasDifferentAvailabilityAfter')
    .withIsAvailable(
      scenario => (
        scenario.grid &&
        scenario.grid.hasGrid24 === false
      ) || false),

  new EnumRule('availabilityTypeBefore', GridAvailability)
    .withIsAvailable(scenario => (
      scenario.grid &&
      scenario.grid.hasGrid24 === false
    ) || false),

  new ObjectRule<GridComplexPricingExt>('gridComplexAvailabilityBefore', [
    new ArrayRule('prices', () => true,
      new MinMaxRule('sample', 0, undefined)
    ),
    new ArrayRule('periods', () => true, new ObjectRule('sample'))
  ])
    .withIsAvailable(scenario => (
      scenario.grid &&
      scenario.grid.hasGrid24 === false &&
      scenario.grid.availabilityTypeBefore === GridAvailability.complex
    ) || false),

  new BooleanRule('hasDifferentAvailabilityAfter')
    .withIsAvailable(scenario => (
      scenario.grid &&
      scenario.grid.hasGrid24 === false
    ) || false),

  new MinMaxRule('averageGridConnectionHoursPerDayBefore', 0, 24, 'hours')
    .withIsAvailable(scenario => (
      scenario.grid &&
      scenario.grid.hasGrid24 === false &&
      scenario.grid.availabilityTypeBefore === GridAvailability.hours
    ) || false),

  new MinMaxRule('averageGridConnectionHoursPerDayBeforePercentage', 0, 1, '%')
    .withIsAvailable(scenario => (
      scenario.grid &&
      scenario.grid.hasGrid24 === false &&
      scenario.grid.availabilityTypeBefore === GridAvailability.percentage
    ) || false)
    .withFactor(100),

  new EnumRule('availabilityTypeAfter', GridAvailability)
    .withIsAvailable(scenario => (
      scenario.grid &&
      scenario.grid.hasDifferentAvailabilityAfter &&
      scenario.grid.hasGrid24 === false
    ) || false),

  new MinMaxRule('averageGridConnectionHoursPerDayAfter', 0, 24, 'hours')
    .withIsAvailable(
      scenario => (
        scenario.grid &&
        scenario.grid.hasGrid24 === false &&
        scenario.grid.hasDifferentAvailabilityAfter &&
        scenario.grid.availabilityTypeAfter === GridAvailability.hours
      ) || false),

  new MinMaxRule('averageGridConnectionHoursPerDayAfterPercentage', 0, 1, '%')
    .withIsAvailable(scenario => (
      scenario.grid &&
      scenario.grid.hasGrid24 === false &&
      scenario.grid.hasDifferentAvailabilityAfter &&
      scenario.grid.availabilityTypeAfter === GridAvailability.percentage
    ) || false)
    .withFactor(100),

  new ObjectRule<GridComplexPricingExt>('gridComplexAvailabilityAfter', [
    new ArrayRule('prices', () => true,
      new MinMaxRule('sample', 0, undefined)
    ),
    new ArrayRule('periods', () => true, new ObjectRule('sample'))
  ]).withIsAvailable(scenario => (
    scenario.grid &&
    scenario.grid.hasGrid24 === false &&
    scenario.grid.hasDifferentAvailabilityAfter &&
    scenario.grid.availabilityTypeAfter === GridAvailability.complex
  ) || false),

  new BooleanRule('hasGridLimitation')
    .withIsAvailable(() => false), // Neutralized rule for now

  new MinMaxRule('limitPower', 0, 10000, 'kWh')
    .withIsAvailable(scenario => (
      scenario.grid &&
      scenario.grid.hasGridLimitation
    ) || false),

  new MinMaxRule('limitPercentage', 0, 5, '%')
    .withIsAvailable(scenario => (
      scenario.grid &&
      scenario.grid.hasGridLimitation
    ) || false)
    .withFactor(100)
])
  .withDefaultValue(() => new DefaultValue(new ScenarioGridExt()))
  .withIsAvailable(scenario => (scenario.hasGrid && !scenario.hasInjectionType(InjectionModelRef.total_injection)) ?? false);
